import "./view.scss";

    document.addEventListener('DOMContentLoaded', function() {
    const shareButtons = document.querySelectorAll('.share-button');

    shareButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const url = this.getAttribute('href');
            
            // Open share dialog in a popup window
            window.open(url, 'Share Dialog', 
                'width=600,height=400,menubar=no,toolbar=no,resizable=yes,scrollbars=yes'
            );
        });
    });
});